import React from "react";
import { Package, Truck } from "lucide-react";

const assetBase = import.meta.env.BASE_URL || "/static/react/";
const loadingImage = `${assetBase}driver-loading-v2.webp`;
const deliveryImage = `${assetBase}driver-delivery-v1.webp`;

export default function DriverPortalStepVisual({ stepType, stopNumber, stopCount, children }) {
  const isLoading = stepType === "loading";
  const Icon = isLoading ? Truck : Package;

  return (
    <div className={`driver-step-visual ${isLoading ? "driver-step-visual--loading" : "driver-step-visual--delivery"}`}>
      <img src={isLoading ? loadingImage : deliveryImage} alt="" aria-hidden="true" />
      <div className="driver-step-visual-copy">
        <span className="driver-stop-kind"><Icon size={15} aria-hidden="true" />{isLoading ? "Chargement" : "Livraison"}</span>
        <p>Arrêt <strong>{stopNumber}</strong> sur {stopCount}</p>
        {children}
      </div>
    </div>
  );
}
